import type { setCurrentElement } from 'actions/current-sheet-item';
import type { Reducer } from 'redux';

import { ACTIONS } from 'actions/current-sheet-item';

interface InitialState {
  currentEleResponseId?: string;
}

type CurrentSheetItemReducer = Reducer<
  InitialState,
  ReturnType<typeof setCurrentElement>
>;

const initialState: InitialState = {
  currentEleResponseId: '',
};

const reducer: CurrentSheetItemReducer = (state = initialState, action) => {
  const { type } = action;

  if (type === ACTIONS.SET_CURRENT_SHEET_ITEM) {
    return {
      ...state,
      currentEleResponseId: action.payload.currentEleResponseId,
    };
  }

  if (type === ACTIONS.RESET_CURRENT_SHEET_ITEM) {
    return initialState;
  }

  return state;
};

export default reducer;
